/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Tag, Typography2, breakpoints } from '@coursera/cds-core';
import { Link, useTracker } from '@coursera/event-pulse/react';

import _t from 'i18n!nls/front-page';

const styles = {
  linksContainer: css`
    margin: var(--cds-spacing-200) 0 var(--cds-spacing-200) 0;

    ${breakpoints.down('sm')} {
      text-align: left;
    }
  `,
  linkStyle: css`
    display: inline-flex;
    margin-right: var(--cds-spacing-100);
    margin-bottom: var(--cds-spacing-100);
    color: var(--cds-color-neutral-primary);
    text-decoration-color: var(--cds-color-neutral-primary);
    text-decoration: underline;

    &:visited {
      text-decoration-color: var(--cds-color-neutral-primary);
    }

    ${breakpoints.down('sm')} {
      margin-right: var(--cds-spacing-200);
    }
  `,
  trendingText: css`
    display: inline-flex;
    padding: 0 var(--cds-spacing-100) var(--cds-spacing-100) 0;
  `,
};

export const trendingTopicsList = [
  { name: () => _t('Machine Learning'), url: '/search?query=Machine%20Learning' },
  { name: () => _t('Project Management'), url: '/search?query=Project%20Management' },
  { name: () => _t('Data Analytics'), url: '/search?query=Data%20Analytics' },
  { name: () => _t('Cybersecurity'), url: '/search?query=Cybersecurity' },
  { name: () => _t('Digital Marketing'), url: '/search?query=Digital%20Marketing' },
  { name: () => _t('AI For Everyone'), url: '/search?query=AI%20For%20Everyone' },
];

const HeroBannerTrendingLinks = () => {
  const tracker = useTracker();

  return (
    <div css={styles.linksContainer}>
      <Typography2
        component="div"
        css={styles.trendingText}
        variant="actionSecondary"
        aria-label={_t('Trending search topics')}
      >
        {_t('Trending')}:
      </Typography2>
      {trendingTopicsList.map(({ name, url }) => {
        const linkName = name();
        return (
          <Link
            href={url}
            css={styles.linkStyle}
            aria-label={_t('Search query for #{name}', { name: linkName })}
            key={linkName}
            trackingData={{
              button: {
                name: 'hero_trending_search_query',
                linkType: 'internal',
                linkURL: url,
              },
            }}
            onClick={() => {
              tracker('perform_search', {
                searchedQuery: linkName,
              });
            }}
          >
            <Tag variant="category" priority="primary">
              {linkName}
            </Tag>
          </Link>
        );
      })}
    </div>
  );
};

export default HeroBannerTrendingLinks;
